module.exports = __webpack_public_path__ + "img/ic_food_pig.6eef5580.png";